import React from "react";

const Filters = ({ children, applyFilters, clearFilters }) => {
  return (
    <div className="w-full  bg-light-green flex justify-center items-center ">
      <div className="max-w-[1280px] w-full flex flex-wrap justify-start items-center ">
        <div className="flex flex-wrap justify-start items-center w-fit">
          {children}
          <button
            className="bg-dark-green text-white rounded-full px-4 m-4 py-2 text-base font-poppins hover:bg-accent-green h-fit"
            onClick={applyFilters}
          >
            Aplicar filtros
          </button>
        </div>
      </div>
    </div>
  );
};

export default Filters;
